import { WxLoginType, VvflyPath } from '@/typeAll';
// 当前是否是呼噜圈 公众号
// import { VvflyPath } from '@/typeAll';

// 判断是否在微信浏览器中
export function isWeChatBrowser() {
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.includes('micromessenger');
}

// export function initWx() {
//     window.wx.config({
//         debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
//         appId: 'wxfbc444c4a7be84ac', // 必填，公众号的唯一标识
//         timestamp: Math.floor(Date.now() / 1000), // 必填，生成签名的时间戳
//         nonceStr: '', // 必填，生成签名的随机串
//         signature: '', // 必填，签名
//         jsApiList: [], // 必填，需要使用的JS接口列表
//     });
// }

// 判断当前页面是否是 呼噜圈 公众号页面
export function nowIsHLQ() {
    const hashStr = location.hash || location.href || '';
    const maintenancePage = '/maintenance';
    if (hashStr.includes(maintenancePage) || hashStr.includes(VvflyPath)) {
        return false;
    }
    return true;
}

// 微信登录
export function wxGetLoginUrl(
    redirectUrl,
    loginType = WxLoginType.userinfo,
    state = '1',
    urlEncode = true,
) {
    const useUrlOrg = redirectUrl || location.href;
    const useUrl = urlEncode ? encodeURIComponent(useUrlOrg) : useUrlOrg;
    const wxAppID = nowIsHLQ() ? process.env.VUE_APP_WX_APPID : process.env.VUE_APP_WX_APPID_VVFLY;
    console.log('wxGetLoginUrl wxAppID', wxAppID);
    let target = '';
    if (loginType === WxLoginType.base) {
        target = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wxAppID}&redirect_uri=${useUrl}&response_type=code&scope=snsapi_base&state=${state}#wechat_redirect`;
    } else {
        target = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wxAppID}&redirect_uri=${useUrl}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`;
    }
    return target;
}

// 微信登录
export function wxLogin(...par) {
    const url = wxGetLoginUrl(...par);
    // console.log(url);
    // alert(url);
    // return;
    // console.log('wxLogin ', url);

    location.href = url;
}
